export default function () {
  return {
    cartorio: {
      attributes: {},
    },
  };
}
